import React from 'react';
import FormModal from './components/common/FormModal';
import DeleteIcon from './components/common/DeleteIcon';
import {Form} from 'semantic-ui-react';

export const CURRENCY_LIST = [
  {
    'text': 'USD',
    'value': 'USD',
    'key': 0,
  },
  {
    'text': 'EUR',
    'value': 'EUR',
    'key': 1,
  },
];

export const ADVISOR_STATUS = [
  {
    'text': 'ACTIVO',
    'value': 'A',
    'key': 'A',
  },
  {
    'text': 'INACTIVO',
    'value': 'I',
    'key': 'I',
  },
];

export const FLOAT_CLIENT_CODE = {
  'DISABLED': '001',
  'DIPLOMATIC_ONG': '002',
  'STATE_INSTITUTION': '003',
  'PROUCTIVE_TRUCK': '005',
};

export const FLOATING_DEALERS = {
  'skioda': '1790656934001',
  'itsa': '0190003701001',
  'toyocosta': '0993144029001',
  'tde': '1792073634001',
};

export const CLIENT_TYPE_LIST = [
  {
    'key': '001',
    'value': '001',
    'text': 'DISCAPACITADO',
  },
  {
    'key': '002',
    'value': '002',
    'text': 'DIPLOMATICOS/ONG',
  },
  {
    'key': '003',
    'value': '003',
    'text': 'INSTITUCION DEL ESTADO',
  },
  {
    'key': '005',
    'value': '005',
    'text': 'CAMIONETA PRODUCTIVA',
  },
];

export const ADVISOR_STATE_FILTER = [
  {
    'key': '',
    'value': '',
    'text': 'TODO',
  },
  {
    'key': 'A',
    'value': 'A',
    'text': 'ACTIVO',
  },
  {
    'key': 'I',
    'value': 'I',
    'text': 'INACTIVO',
  },
];

export const BASE_DATE = new Date(2000, 0, 1);

export const generateClientColumns = ({isAvailable, isUserTde}) => {
  const hiddenColumns = ['dealerName'];
  const columns = [
    {
      'Header': 'CÉDULA',
      'accessor': 'document',
    },
    {
      'Header': 'NOMBRES',
      'accessor': 'clientFullName',
      'Cell': ({row}) => {
        const values = row.original;
        return <div className='large-text-table'>
          {`${values.clientFullName}`}
        </div>;
      },
    },
    {
      'Header': 'TIPO DE CLIENTE',
      'accessor': 'clientTypeDescription',
    },
    {
      'Header': '% EXONERACIÓN',
      'accessor': 'exonerationPerc',
    },
    {
      'Header': 'DIRECCIÓN',
      'accessor': 'location',
      'Cell': ({row}) => {
        const values = row.original;
        return <div className='large-text-table'>
          {`${values.location || ''}`}
        </div>;
      },
    },
    {
      'Header': 'DEALER',
      'accessor': 'dealerName',
    },
    {
      'Header': 'TIENE RESERVA',
      'accessor': 'hasReservations',
    },
    {
      'id': 'actions',
      'Header': 'ACCIONES',
      'Cell': ({row}) => {
        return (
          <>
            <FormModal
              detail="cliente"
              code={row.original.document}
              dealerRuc={row.original?.dealerRuc}
              headerTitle="Editar cliente"
              create={false}
              contentType="client"
            />
            <DeleteIcon
              dataType="client"
              code={row.original.document}
              disabled={!isAvailable}
              dealerRuc={row.original?.dealerRuc}
            />
          </>
        );
      },
    },
  ];
  if (isUserTde) {
    return columns;
  }
  return columns.filter((column) => !hiddenColumns.includes(column.accessor));
};

export const advisorColumns = ({isAvailable}) => [
  {
    'Header': 'CÉDULA',
    'accessor': 'code',
  },
  {
    'Header': 'NOMBRES',
    'accessor': 'name',
  },
  {
    'Header': 'DEALER',
    'accessor': 'dealerName',
  },
  {
    'Header': 'ESTADO',
    'accessor': 'status',
    'Cell': ({row}) => <>{row.original.statusName}</>,
    'Filter': ({'column': {filterValue, setFilter, preFilteredRows, id}}) => {
      return (
        <Form.Select
          placeholder="TODO"
          selection
          value={filterValue}
          onChange={(e, {value}) => setFilter(value)}
          options={ADVISOR_STATE_FILTER}
        />
      );
    },
  },
  {
    'Header': 'ÚLTIMA CONEXIÓN',
    'accessor': 'daysNoConnect',
  },
  {
    'id': 'actions',
    'Header': 'ACCIONES',
    'Cell': ({row}) => {
      return (
        <>
          <FormModal
            detail="asesor"
            code={row.original.code}
            headerTitle="Editar Asesor"
            create={false}
            contentType="advisor"
            disabled={!isAvailable}
          />
          <DeleteIcon
            dataType="advisor"
            code={row.original.code}
            disabled={!isAvailable}
          />
        </>
      );
    },
  },
];

export const exemptionColumns = [
  {
    'Header': 'RANGO DE PORCENTAJE DE DISCAPACIDAD (%)',
    'id': 'exoneracion',
    'disableFilters': true,
    'columns': [
      {
        'Header': 'DE',
        'accessor': 'disabilityPercentajeFrom',
      },
      {
        'Header': 'HASTA',
        'accessor': 'disabilityPercentajeTo',
      },
    ],
  },
  {
    'Header': 'EXONERACION (%)',
    'accessor': 'exonerationPercentaje',
  },
  {
    'id': 'actions',
    'Header': 'ACCIONES',
    'disableFilters': true,
    'Cell': ({row}) => {
      return (
        <>
          <FormModal
            detail="exoneracion"
            code={row.original.id}
            headerTitle="Editar rango de porcentaje"
            create={false}
            contentType="exemption"
          />
          <DeleteIcon dataType="exemption" code={row.original.id} />
        </>
      );
    },
  },
];

export const rawAttachmentInfo = {
  'clientId': {
    'name': 'CÉDULA',
  },
  'infoCertification': {
    'name': 'CERTIFICACIÓN DE VERIFICACIÓN DE LA INFORMACIÓN',
  },
  'disabilityCard': {
    'name': 'CARNET DE DISCAPACIDAD',
  },
  'billFile': {
    'name': 'FACTURA DE LUZ O TELÉFONO',
  },
  'legalRep': {
    'name': ' DOCUMENTOS REPRESENTANTE LEGAL',
  },
};

export const colorTypes = [
  {
    'key': 'STD',
    'value': 'STD',
    'text': 'ESTÁNDAR',
  },
  {
    'key': 'OPT',
    'value': 'OPT',
    'text': 'OPCIONAL',
  },
  {
    'key': 'OPTA',
    'value': 'OPTA',
    'text': 'OPCIONAL A',
  },
  {
    'key': 'OPTB',
    'value': 'OPTB',
    'text': 'OPCIONAL B',
  },
];

export const pricesActions = {
  'read': 'readProduction',
  'editDate': 'editProductionDate',
  'editPrices': 'editProductionPrices',
  'addProduction': 'addProduction',
};
